<template>
  <a-card title="员工优惠">
    <a-collapse v-model="activeKey">
      <a-collapse-panel key="1" header="This is panel header 1">
        <p>{{ text }}</p>
      </a-collapse-panel>
      <a-collapse-panel key="2" header="This is panel header 2" :disabled="false">
        <p>{{ text }}</p>
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>
<script>
export default {
  name: 'EmployeeDiscount',
  data() {
    return {
      activeKey: ['1', '2'],
      text: 'This is panel content'
    }
  }
}
</script>

<style scoped lang="less">

</style>